import Alert from "../../../../../global/components/Alert/Alert.vue";
import FormElement from "../../../../../global/components/FormElement/FormElement.vue";
import PuxTranslate from "../../../../../global/components/PuxTranslate/PuxTranslate.vue";

import FieldsMixin from "./FieldsMixin";

import moment from "moment";
import {
  cloneDeep,
  forEach,
  size,
} from "lodash-es";

// @vue/component
export default {
  name: "ImportauftragAntragWizardStepVorbereiten",
  components: {
    Alert,
    FormElement,
    PuxTranslate,
  },
  mixins: [
    FieldsMixin
  ],
  props: {
    angebote: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => {}
    },
    updateModel: {
      type: Function,
      default: undefined,
    },
  },
  data() {
    return {
      editModel: {
        angebot: undefined,
        antragsdatum: undefined,
        file: undefined,
      }
    };
  },
  created() {
    this.initModel();
    this.initErrorLabels();
  },
  methods: {
    initModel() {
      this.editModel.antragsdatum = moment().format("YYYY-MM-DD");
      this.onUpdateModel();
    },

    initErrorLabels() {
      const ERROR_LABELS = {
        non_field_errors: ""
      };
      forEach(this.fields, field => {
        ERROR_LABELS[field.id] = field.label;
      });
      this.errorLabels = ERROR_LABELS;
    },

    showErrors() {
      return size(this.errors);
    },

    onUpdateModel() {
      const MODEL_CLONE = cloneDeep(this.editModel);
      this.updateModel({ model: MODEL_CLONE });
    },
  },
};
